import React, { Fragment, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import ProductMetricsSingle from "./ProductMetricsSingle";
import customConfig from "../../config";
import { getMetricsData } from "../../action/report";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import Grid2 from "@mui/material/Grid2";
import { Box, Paper } from "@mui/material";
import Dialog from "../Common/Dailog/Dailog";
import ScreenLoader from "../Common/ScreenLoader/ScreenLoader";
import EmptyState from "../Common/EmptyState/EmptyState";
import { PageHeading, ValueText } from "../Common/Typography/AppTypography";
import missing_logo from "../../assets/no-found.png";

const METRICS_COUNT = 13;

const getMetricsConfig = () => {
  const items = [];
  for (let i = 1; i <= METRICS_COUNT; i++) {
    const title = customConfig[`productMetricsTitle${i}`];
    const fileName = customConfig[`productMetricsFileName${i}`];
    if (title && fileName) items.push({ title, fileName });
  }
  return items;
};

const ProductMetrics = ({
  getMetricsData,
  wrapperClass,
  reportData: { metricsData, metricsError, metricsLoading },
}) => {
  const [showSelected, setShowSelected] = useState(false);
  const [title, setTitle] = useState("");
  const [imgSrc, setImgSrc] = useState("");

  const metricsConfig = useMemo(getMetricsConfig, []);

  useEffect(() => {
    getMetricsData();
    const timer = setInterval(
      () => getMetricsData(),
      1000 * 60 * 60 * customConfig.productMetricsRefreshHour
    );
    return () => clearInterval(timer);
  }, [getMetricsData]);

  const getImageSource = (imgName) => {
    const item = metricsData?.find((m) => m.fileName === imgName);
    return item ? `data:image/jpeg;base64,${item.base64}` : missing_logo;
  };

  const handleReportSelection = (reportTitle, imgName) => {
    setTitle(reportTitle);
    setImgSrc(getImageSource(imgName));
    setShowSelected(true);
  };

  const handleDialogClose = () => {
    setShowSelected(false);
  };

  if (metricsLoading) {
    return (
      <ResponsiveContentWrapper className={wrapperClass || ""}>
        <ScreenLoader
          height="100%"
          sx={{ minHeight: "calc(100vh - 80px)", backgroundColor: "background.default" }}
        />
      </ResponsiveContentWrapper>
    );
  }

  return (
    <Fragment>
      <ResponsiveContentWrapper className={wrapperClass || ""}>
        <Box sx={{ width: "100%", minWidth: 0, boxSizing: "border-box", pb: 3 }}>
          <PageHeading sx={{ mb: 2 }}>Product Metrics</PageHeading>

          <Dialog
            open={showSelected}
            onClose={handleDialogClose}
            showCloseButton
            closeOnBackdropClick
            closeOnEscapeKeyDown
            maxWidth="md"
            PaperProps={{ sx: { borderRadius: 2 } }}
          >
            <ProductMetricsSingle reportTitle={title} imageURL={imgSrc} />
          </Dialog>

          {metricsData && metricsData.length > 0 ? (
            <Grid2
              container
              spacing={2}
              sx={{
                width: "100%",
                minWidth: 0,
                "& > .MuiGrid2-root": { minWidth: 0 },
              }}
            >
              {metricsConfig.map(({ title: metricTitle, fileName }) => (
                <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={fileName} sx={{ minWidth: 0 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      cursor: "pointer",
                      transition: "box-shadow 0.2s",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      "&:hover": { boxShadow: 2 },
                    }}
                    onClick={() => handleReportSelection(metricTitle, fileName)}
                  >
                    <Box sx={{ mb: 1, display: "flex", justifyContent: "center" }}>
                      <Box
                        component="img"
                        src={getImageSource(fileName)}
                        alt={metricTitle}
                        sx={{
                          width: "100%",
                          maxWidth: 200,
                          minHeight: 150,
                          height: 150,
                          objectFit: "contain",
                          display: "block",
                          mx: "auto",
                        }}
                      />
                    </Box>
                    <ValueText sx={{ fontSize: 12, textAlign: "center" }}>
                      {metricTitle}
                    </ValueText>
                  </Paper>
                </Grid2>
              ))}
            </Grid2>
          ) : (
            <Paper variant="outlined" sx={{ overflow: "hidden" }}>
              <EmptyState
                message={
                  metricsError?.msg || customConfig.noProductMetricsMsg
                }
                minHeight="200px"
              />
            </Paper>
          )}
        </Box>
      </ResponsiveContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  reportData: state.report,
});

export default connect(mapStateToProps, { getMetricsData })(ProductMetrics);
